import api from "./api";

/** Alias Compass — Decision Intelligence API bindings. */
export const compassApi = {
  // Frameworks
  listFrameworks: (projectId) => api.get(`/projects/${projectId}/frameworks`),
  createFramework: (projectId, payload) =>
    api.post(`/projects/${projectId}/frameworks`, payload),
  draftFrameworkFromBrief: (projectId, brief, target_type) =>
    api.post(`/projects/${projectId}/frameworks/draft-from-brief`,
              { brief, target_type }),
  getFramework: (id) => api.get(`/frameworks/${id}`),
  updateFramework: (id, payload) => api.put(`/frameworks/${id}`, payload),
  deleteFramework: (id) => api.delete(`/frameworks/${id}`),

  // Handoff (Advanced flow — user picks framework)
  handoff: (payload) => api.post(`/compass/handoff`, payload),

  // Auto-evaluate (Simplification v3 — normal flow, no framework picker)
  evaluate: (payload) => api.post(`/compass/evaluate`, payload),

  // Evaluations
  createEvaluation: (payload) => api.post(`/evaluations`, payload),
  getEvaluation: (id) => api.get(`/evaluations/${id}`),
  updateEvaluation: (id, payload) => api.put(`/evaluations/${id}`, payload),
  finalizeEvaluation: (id) => api.post(`/evaluations/${id}/finalize`),
  reopenEvaluation: (id) => api.post(`/evaluations/${id}/reopen`),
  deleteEvaluation: (id) => api.delete(`/evaluations/${id}`),
  listProjectEvaluations: (projectId) =>
    api.get(`/projects/${projectId}/evaluations`),

  // Evidence
  addEvidence: (evaluationId, payload) =>
    api.post(`/evaluations/${evaluationId}/evidence`, payload),
  deleteEvidence: (id) => api.delete(`/evidence/${id}`),

  // Dossier
  subjectDossier: (targetType, targetId) =>
    api.get(`/compass/subject/${targetType}/${targetId}/history`),

  // LLM + alternate fit
  llmDraft: (evaluationId) => api.post(`/evaluations/${evaluationId}/llm-draft`),
  alternateFits: (evaluationId, llmJustify = true) =>
    api.get(`/evaluations/${evaluationId}/alternate-fits?llm_justify=${llmJustify}`),

  // Promote freeform → Contact
  promoteSubject: (payload) => api.post(`/compass/promote-subject`, payload),
};
